import { render, staticRenderFns } from "./gatorz-policy.vue?vue&type=template&id=6710e7b5&scoped=true&"
import script from "./gatorz-policy.vue?vue&type=script&lang=js&"
export * from "./gatorz-policy.vue?vue&type=script&lang=js&"
import style0 from "./gatorz-policy.vue?vue&type=style&index=0&id=6710e7b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6710e7b5",
  null
  
)

export default component.exports